import { debounce } from "./utils";
import {
  openMediaModal,
  closeMediaModal,
  freezeBodyScroll,
  freeBodyScroll,
} from "./media-modal";

export const accessibilityOptionsMFP = {
  // accessibility:
  // ? see https://www.minddevelopmentanddesign.com/blog/how-to-create-a-web-accessible-modal-window-with-magnific-popup/
  closeBtnInside: true,
  autoFocusLast: true,
  focus: ".mfp-close",
};

(function ($) {
  $(() => {
    // Article media modal.
    $(".button-media").on("click", function (e) {
      e.preventDefault();

      const count = this.dataset.count;

      // Trigger modal only if media count is greater than zero.
      if (count > 0) {
        jQuery.magnificPopup.open({
          items: {
            src: "#mediamodal",
            type: "inline",
          },
          mainClass: "mediamodal",
          callbacks: {
            open: function () {
              openMediaModal(0);
            },
            close: function () {
              closeMediaModal();
            },
            beforeOpen: function () {
              $("body").addClass("modal-open");
            },
            beforeClose: function () {
              $("body").removeClass("modal-open");
            },
          },
          ...accessibilityOptionsMFP,
        });
      }
    });

    // Article: for images in the content.
    $(".article-content img, .gallery-image-image img").on(
      "click",
      function () {
        // Find the index of the clicked item for the media modal. Ideally we use the image id in the wrapping figure
        let index = 0;
        const wrappingFigure = this.closest("figure");
        if (wrappingFigure && wrappingFigure.dataset.imageId) {
          const modalItems = Array.from(
            document.querySelectorAll("#mediamodal .mediamodal-media")
          );
          for (const [itemIndex, modalItem] of Object.entries(modalItems)) {
            if (wrappingFigure.dataset.imageId == modalItem.dataset.id) {
              index = itemIndex;
              break;
            }
          }
        } else {
          // If the id isn't present (for instance if it's a default WordPress block not going through the theme's code) we just use the order it's presented in the content
          const images = document.querySelector(".article-content")
            ? Array.from(document.querySelectorAll(".article-content img"))
            : document.querySelector(".gallery-image-image")
            ? Array.from(document.querySelectorAll(".gallery-image-image img"))
            : null;
          if (images && images.length > 0) {
            index = images.indexOf(this);
          }
        }
        jQuery.magnificPopup.open({
          items: {
            src: "#mediamodal",
            type: "inline",
          },
          mainClass: "mediamodal",
          callbacks: {
            open: function () {
              openMediaModal(index);
            },
            close: function () {
              closeMediaModal();
            },
            beforeOpen: function () {
              $("body").addClass("modal-open");
            },
            beforeClose: function () {
              $("body").removeClass("modal-open");
            },
          },
          ...accessibilityOptionsMFP,
        });
      }
    );

    // Feedback form.
    $(".button-feedback").magnificPopup({
      mainClass: "article-feedback-modal",
      callbacks: {
        beforeOpen: function () {
          $("body").addClass("modal-open");
        },
        beforeClose: function () {
          $("body").removeClass("modal-open");
        },
      },
      ...accessibilityOptionsMFP,
    });

    // Cite.
    $(".button-citation").magnificPopup({
      mainClass: "article-citation-modal",
      callbacks: {
        beforeOpen: function () {
          $("body").addClass("modal-open");
        },
        beforeClose: function () {
          $("body").removeClass("modal-open");
        },
        open: freezeBodyScroll,
        close: freeBodyScroll,
      },
      ...accessibilityOptionsMFP,
    });
    /**
     * Interesting case with citation modals. Users often will drag to select text
     * within the modal, and if not precise, will land off the modal, triggering
     * magnific to close.
     *
     * Here we make a little hack around this, on mousedown, we'll inject an invisible
     * "blocker" div between the modal content and the modal backdrop, and clear
     * it again on mouseup. This way, we can block mouse-up on the modal backdrop.
     *
     * Note: first tried stop propagation, but that doesn't work as the event target
     * for mouseup **is** the modal backdrop.
     */
    $(document.body).on("mousedown", ".modal-citation", (e) => {
      const blocker = document.createElement("div");
      blocker.classList.add("mousedown-blocker");
      blocker.style.cssText = `
          height: 100%;
          width: 100%;
          position: fixed;
          z-index: -1;
          left: 0;
          top: 0;
        `;
      e.target.closest(".modal-citation").appendChild(blocker);
    });
    $(document.body).on("mouseup", () => {
      const blocker = document.querySelector(".mousedown-blocker");
      if (blocker) blocker.remove();
    });

    // Sharer form.
    $(".button-share").magnificPopup({
      mainClass: "article-share-modal",
      callbacks: {
        beforeOpen: function () {
          $("body").addClass("modal-open");
        },
        beforeClose: function () {
          $("body").removeClass("modal-open");
        },
        open: freezeBodyScroll,
        close: freeBodyScroll,
      },
      ...accessibilityOptionsMFP,
    });

    // Attachment Feedback form.
    $(".js-btn-feedback").magnificPopup({
      mainClass: "attachment-feedback-modal",
      callbacks: {
        beforeOpen: function () {
          $("body").addClass("modal-open");
        },
        beforeClose: function () {
          $("body").removeClass("modal-open");
        },
      },
      ...accessibilityOptionsMFP,
    });

    // Snippet Sharer form.
    $(".button-share-snippet").magnificPopup({
      mainClass: "article-share-modal",
      callbacks: {
        open: freezeBodyScroll,
        close: function () {
          let snippetWrapContainer = document.querySelector(".snippet-wrap");
          snippetWrapContainer.classList.remove("active");
          freeBodyScroll();
        },
        beforeOpen: function () {
          $("body").addClass("modal-open");
        },
        beforeClose: function () {
          $("body").removeClass("modal-open");
        },
      },
      ...accessibilityOptionsMFP,
    });

    // Exhibition.
    $(".exhibition-content .chapter-image").on("click", function (e) {
      e.preventDefault();
      const currentId = $(this).data("id");

      const allMedias = Array.from(
        document.querySelectorAll("#mediamodal .mediamodal-media")
      );

      let index = 0;
      let cnt = 0;

      for (let i = 0; i < allMedias.length; i++) {
        const attachmentId = allMedias[i].getAttribute("data-id");
        if (attachmentId == currentId) {
          index = cnt;
        }
        cnt++;
      }

      jQuery.magnificPopup.open({
        items: {
          src: "#mediamodal",
          type: "inline",
        },
        mainClass: "mediamodal",
        callbacks: {
          open: function () {
            openMediaModal(index);
          },
          close: function () {
            closeMediaModal();
          },
          beforeOpen: function () {
            $("body").addClass("modal-open");
          },
          beforeClose: function () {
            $("body").removeClass("modal-open");
          },
        },
        ...accessibilityOptionsMFP,
      });
    });

    // Fix VH on mobile with CSS variable
    function mobileCssVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    mobileCssVh();
    window.addEventListener("resize", debounce(mobileCssVh, 100));
  });
})(jQuery);
